// src/components/HomeLink.tsx
// A visible way back to /home from every page the home links to. Rendered only when signed in.
import { Link, useLocation } from "react-router-dom";
import { House } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const HomeLink = ({ className = "" }: { className?: string }) => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user || pathname === "/home") return null;
  return (
    <Link
      to="/home"
      aria-label="Home"
      className={`inline-flex h-7 items-center gap-1 rounded-full border border-border/50 bg-card px-2.5 text-xs font-medium text-foreground hover:bg-card/80 ${className}`}
    >
      <House className="h-3.5 w-3.5 text-primary" />
      <span>Home</span>
    </Link>
  );
};
